import { motion } from "framer-motion";
import { useSiteLang } from "../lib/siteLang";
import { StoreButtons } from "./StoreButtons";

export const Hero = () => {
  const { t } = useSiteLang();

  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      {/* Real photo with the navy scrim, like the hero art of the app */}
      <div className="absolute inset-0 z-0">
        <picture>
          <source srcSet="/images/hero-faraglioni.webp" type="image/webp" />
          <img src="/images/hero-faraglioni.jpg" alt="" className="w-full h-full object-cover" fetchPriority="high" />
        </picture>
        <div className="absolute inset-0 hero-gradient" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-5 md:px-10 pt-32 pb-20 md:pt-40 md:pb-28 grid lg:grid-cols-[1.15fr_0.85fr] gap-12 items-center">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="section-label mb-5"
            data-testid="hero-label"
          >
            {t.eyebrow}
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-tagline text-5xl sm:text-6xl lg:text-7xl text-white leading-[1.05] mb-6 text-balance"
            style={{ textWrap: "balance" }}
            data-testid="hero-title"
          >
            {t.tagline}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.6 }}
            className="text-lg md:text-xl text-white/80 mb-8 max-w-xl"
            data-testid="hero-subtitle"
          >
            {t.lead}
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4, duration: 0.6 }}>
            <StoreButtons />
            <p className="mt-5 text-sm text-white/70">
              <span className="inline-block rounded-full bg-[#FF6B00]/20 text-[#FF6B00] font-semibold px-3 py-0.5 mr-2">{t.free}</span>
              {t.freeNote}
            </p>
          </motion.div>
        </div>

        {/* The real screen of the app */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="flex justify-center"
        >
          <div className="animate-float w-[13.5rem] sm:w-60 lg:w-[17rem] rounded-[2.5rem] overflow-hidden border-[5px] border-[#0C1A2E] ring-1 ring-white/15 shadow-2xl" data-testid="hero-phone">
            <img src="/images/screenshot-tour-home.webp" alt="GozzoGuide — Tour di Capri" className="w-full h-auto block" width="640" height="1254" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
